import React, { useEffect, useState } from 'react'
import Header from '../../components/Header'
import {
    Box,
    Button,
    Flex,
    Icon,
    Input,

    InputGroup,

    InputLeftElement,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    SimpleGrid,
    Text,
    useDisclosure,
} from '@chakra-ui/react'
import { LuDollarSign, LuFileText, LuWallet, LuCalendar, LuSearch } from 'react-icons/lu'
import BillingTable from './BillingTable/BillingTable'
import Select from 'react-select'
import InvoiceGenerationForm from './GenerateBilling/GenerateBilling'
import { fetchWrapper } from '../../helpers'
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper'




const Billing = () => {
    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('All')
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [statsData, setStatsData] = useState(null);


    const statCards = statsData
        ? [
            {
                label: 'Total Revenue',
                value: `PKR ${Number(statsData.totalRevenue).toLocaleString()}`,
                icon: <LuDollarSign />,
                color: 'green.400',
            },
            {
                label: 'Outstanding',
                value: `PKR ${Number(statsData.outstanding).toLocaleString()}`,
                icon: <LuWallet />,
                color: 'blue.400',
            },
            {
                label: 'Total Invoices',
                value: statsData.totalInvoice,
                icon: <LuFileText />,
                color: 'purple.400',
            },
            {
                label: 'Overdue',
                value: statsData.overdue,
                icon: <LuCalendar />,
                color: 'orange.400',
            },
        ]
        : [];
    const fetchInvoices = async () => {
        setLoading(true);
        try {
            const query = new URLSearchParams({
                search,
                status: status === 'All' ? '' : status,
                page: activePage,
                limit: itemsPerPage,
            }).toString();

            const url = `${process.env.REACT_APP_API_URL}/invoice/list?${query}`;
            const res = await fetchWrapper.get(url);

            setInvoices(res?.data || []);
            setStatsData(res.header)
            setTotalItems(res?.pagination?.totalItems || 0);
            setItemsPerPage(res?.pagination?.itemsPerPage || 10);
        } catch (err) {
            console.error('Error fetching invoices', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setActivePage(1); // reset to page 1 on search/status change
    }, [search, status]);

    useEffect(() => {
        fetchInvoices();
    }, [activePage, search, status]);
    const statusOptions = [
        { value: '', label: 'All Statuses' },     // no filter
        { value: '1', label: 'Pending' },
        { value: '2', label: 'Overdue' },
        { value: '100', label: 'Paid' },
    ]


    const customSelectStyles = {
        control: (base) => ({
            ...base,
            backgroundColor: '#f9fbfc',
            border: 'none',
            height: '42px',
            boxShadow: 'none',
            minWidth: 180,
        }),
        indicatorSeparator: () => null,
        dropdownIndicator: (base) => ({
            ...base,
            color: '#718096',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#2D3748',
            fontWeight: 500,
        }),
    }



    return (
        <>
            <Header />
            <Modal isOpen={isOpen} onClose={onClose} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Modal Title</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <InvoiceGenerationForm onClose={onClose} />
                    </ModalBody>


                </ModalContent>
            </Modal>
            <BoxWrapper>
                <Box
                    border="1px solid #0000001a"
                    borderRadius="12px"
                    bg="white"
                    p={4}
                    mb={4}
                >
                    <Flex
                        direction={{ base: 'column', md: 'row' }}
                        justify="space-between"
                        align={{ base: 'flex-start', md: 'center' }}
                        gap={3}
                    >
                        <Box>
                            <Text fontSize="md" fontWeight="bold" mb={1}>
                                Billing Management
                            </Text>
                            <Text fontSize="xs" color="gray.500">
                                Manage customer invoices and billing records
                            </Text>
                        </Box>
                        <Button colorScheme="blue" size="sm" leftIcon={<LuFileText />} onClick={onOpen}>
                            Generate Invoice
                        </Button>
                    </Flex>
                </Box>

                <Box
                    border="1px solid #0000001a"
                    borderRadius="12px"
                    bg="white"
                    p={3}
                    mb={4}
                >
                    <Flex direction={{ base: 'column', md: 'row' }} gap={3} justifyContent="space-between">
                        <InputGroup maxW="400px">
                            <InputLeftElement pointerEvents="none">
                                <Icon as={LuSearch} color="gray.400" />
                            </InputLeftElement>
                            <Input
                                bg="gray.50"
                                placeholder="Search by customer or invoice number..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </InputGroup>

                        <Box>
                            <Select
                                styles={customSelectStyles}
                                options={statusOptions}
                                value={statusOptions.find((opt) => opt.value === status)}
                                onChange={(opt) => setStatus(opt.value)}
                            />
                        </Box>
                    </Flex>
                </Box>

                <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={3} mb={4}>
                    {statCards.map((stat, index) => (
                        <Box
                            key={index}
                            bg="white"
                            border="1px solid #0000001a"
                            borderTop="2px solid #2563eb"
                            borderRadius="12px"
                            p={4}
                            transition="box-shadow 0.2s ease, transform 0.2s ease"
                            _hover={{ boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)', transform: 'translateY(-2px)' }}
                        >
                            <Flex align="center" gap={3}>
                                <Flex align="center" justify="center" boxSize="36px" borderRadius="8px" bg="brand.50" flexShrink={0}>
                                    <Box fontSize="lg" color={stat.color}>
                                        {stat.icon}
                                    </Box>
                                </Flex>
                                <Box>
                                    <Text fontSize="xs" color="gray.500">
                                        {stat.label}
                                    </Text>
                                    <Text fontSize="lg" fontWeight="bold">
                                        {stat.value}
                                    </Text>
                                </Box>
                            </Flex>
                        </Box>
                    ))}
                </SimpleGrid>

                <Box
                    border="1px solid #0000001a"
                    borderRadius="12px"
                    bg="white"
                    p={4}
                >
                    <Text fontSize="sm" fontWeight="bold" mb={3}>
                        Billing Records
                    </Text>
                    <BillingTable search={search} status={status} invoices={invoices} loading={loading} activePage={activePage} totalItems={totalItems} setActivePage={setActivePage} itemsPerPage={itemsPerPage} />
                </Box>
            </BoxWrapper>
        </>
    )
}

export default Billing
